module.exports = __webpack_public_path__ + "media/images/icons/twotone/tags-a44f13e773d7feb0b819e556ec8ce637.svg";